module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-20 ovf-hd"
  }, [_c('div', {
    staticClass: "fl m-r-30"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'user_add_companyList',
          params: {
            id: _vm.id
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("  添加企业")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fl w-400"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入企业号/企业名/联系人/电话/邮箱/部门/职位",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1), _c('span', {
    staticClass: "m-l-30"
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700",
      "margin-top": "7px",
      "color": "#111"
    }
  }, [_vm._v(_vm._s(_vm.user_name) + "  (" + _vm._s(_vm.username) + ")")])])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_code",
      "label": "企业号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "企业名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_user",
      "label": "企业联系人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_phone",
      "label": "企业电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_email",
      "label": "企业邮箱"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "breach_name",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "position_name",
      "label": "职位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.examine_status == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("通过")]) : (scope.row.examine_status == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v("审核中")]) : (scope.row.examine_status == -1) ? _c('span', {
          staticStyle: {
            "color": "#d00"
          }
        }, [_vm._v("删除")]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'user'
    },
    on: {
      "closeMain": _vm.init
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30e065e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/user/user_company.vue
// module id = 1821
// module chunks = 2